import { Button } from 'antd';
import React, { useRef } from 'react'
import { colorPredefinedForecasts, purple } from '../utils';
import dayjs from 'dayjs';
import CustomIcon from '../CustomIcon';
import prediction from '../../assets/images/predictions.png';
import { RxUpdate } from 'react-icons/rx';

const buttonConfigs = [96, 48, 24, 12, 6];

const PredefinedButtons = ({ 
    setChartOptions,
    setLinePositions,
    linePositions, 
    draggableLinePosition, 
    setNewForecastLineTimestamp, 
    setIsAddNewForecast,
    setOpen,
    setSteps,
    ref44,
    ref45,
    startDatePrediction,
    setCompareChartOptions,
    compareChartOptions
  }) => {

    const ref1 = useRef(null);
    const ref2 = useRef(null);
    const ref3 = useRef(null);

    const steps = [
      {
        title: 'Prédictions prédéfinies',
        description: 'Choisir une prédiction antérieure parmis les intervalles prédéfinis',
        target: () => ref1.current,
      },
      {
        title: 'Prédictions prédéfinies',
        description: 'Afficher des prédictions antérieurs de 6 heures avant à 4 jours avant pour comparer avec la prédiction présente',
        target: () => ref2.current,
      },
      {
        title: 'Prédictions prédéfinies',
        description: 'Effacer toutes les prédictions en 1 click !',
        target: () => ref3.current,
      },
      {
        title: 'Prédictions prédéfinies',
        description: "Un tag correspondant à la ligne de prédiction s'affiche avec la couleur correspondante. Vous avez la possibilité de la retirer si vous le souhaitez.",
        target: () => ref44.current,
      },
      {
        title: 'Prédictions prédéfinies',
        description: "Au survol des prédictions vous affichez les données de chacune avec les données de précipitations",
        cover: (
          <img src={prediction} alt="données de prédictions" />
        ),
        target: () => ref45.current,
      },
    ]

    const isDisabledBtn = (hours) => {
      const newPosition = dayjs(draggableLinePosition).subtract(hours, 'hour').valueOf();
      const isBeforeStart = newPosition < startDatePrediction;

      const alreadyUsed = linePositions?.some(line => line.hour === hours);
      const has5Forecasts = linePositions.length === 5;

      return isBeforeStart || alreadyUsed || has5Forecasts;
  };


    const handleAddPredefinedForecast = (hour) => {
        if (draggableLinePosition !== null) {
          const colorForecast = colorPredefinedForecasts(hour);
          const newForecastPosition = dayjs(draggableLinePosition).subtract(hour, 'hour').valueOf();
          setNewForecastLineTimestamp({ date: newForecastPosition, color: colorForecast, hour });
          setIsAddNewForecast(true);
        }
      };


      const handleResetLinePositions = () => {
        setChartOptions((prevOptions) => {
          return {
            ...prevOptions,
            series: prevOptions?.series?.filter((series) => !series.name.startsWith("T-")),
            xAxis: {
              ...prevOptions?.xAxis,
              plotLines: prevOptions?.xAxis?.plotLines?.filter(plotLine => plotLine.color === purple),
            },
          };
        });
        if (compareChartOptions) {
          setCompareChartOptions((prevOptions) => {
            return {
              ...prevOptions,
              series: prevOptions?.series?.filter((series) => !series.name.startsWith("T-")),
              xAxis: {
                ...prevOptions?.xAxis,
                plotLines: prevOptions?.xAxis?.plotLines?.filter(plotLine => plotLine.color === purple),
              },
            };
          });
        }
        setLinePositions([]);
        setNewForecastLineTimestamp(null)
      };

  return (
    <>
        <h2 className="info-bulle" ref={ref1}>
          Prédictions comparatives antérieures
          <CustomIcon setOpen={setOpen} setSteps={setSteps} steps={steps} />
        </h2>
      <section ref={ref45} className='predefinedButtons'>
        {buttonConfigs.map((hours) =>  (
            <Button
            ref={ref2}
              className='predefinedButton'
              key={hours}
              onClick={() => handleAddPredefinedForecast(hours)}
              disabled={isDisabledBtn(hours)}
            >
              -{hours}h
            </Button>
          ))}
          {/* <Button ref={ref3} className='reinitButton' disabled={linePositions.length === 0} onClick={handleResetLinePositions}>
            Réinitialiser
          </Button> */}
          <RxUpdate ref={ref3} className="erase" size={21} color="red" onClick={handleResetLinePositions} title="réinitialiser" />
          
      </section>
    </>
  )
}

export default PredefinedButtons
